import React from 'react'

import loadingImage from './loading-circle.svg'

const LoadingSection = () => (
  <div>
    <img src={loadingImage} alt="loading" />
  </div>
)

export default LoadingSection
